var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcQuotes = function SvgIcQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 21,
    fill: "none",
    viewBox: "0 0 28 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.848 7.806.51-6.505C7.4.765 6.682.549 6.422 1.02l-5.33 9.64a6.462 6.462 0 1 0 5.755-2.854M21.925 7.806l.51-6.505c.042-.536-.676-.752-.936-.281l-5.33 9.64c-.857 1.308-1.092 2.265-1.092 3.596a6.462 6.462 0 1 0 6.848-6.45"
  }))));
};
export default SvgIcQuotes;